import { useState, useEffect } from 'react';
import axios from 'axios';
import { PlayCircle, X, Sparkles } from 'lucide-react';
import { startStaffTour } from '../lib/staffTour';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// First-login nudge: offers the interactive tour to brand-new staff exactly once.
// Persists "seen" on the user record so it never nags again, on any device.
export default function TourWelcome({ user }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || String(user.role).toLowerCase() === 'supplier') return;
    let active = true;
    axios.get(`${API}/auth/ui-prefs`)
      .then(({ data }) => { if (active && !data?.tour_seen) setShow(true); })
      .catch(() => {});
    return () => { active = false; };
  }, [user]);

  const markSeen = () => { axios.post(`${API}/auth/ui-prefs/tour-seen`).catch(() => {}); };
  const start = () => { markSeen(); setShow(false); setTimeout(() => startStaffTour(), 250); };
  const dismiss = () => { markSeen(); setShow(false); };

  if (!show) return null;

  return (
    <div className="fixed bottom-5 right-5 z-[60] w-[320px] max-w-[calc(100vw-2.5rem)] animate-in fade-in slide-in-from-bottom-4"
      data-testid="tour-welcome">
      <div className="rounded-2xl bg-[#0B2942] text-white shadow-2xl border border-white/10 overflow-hidden">
        <div className="p-5 relative">
          <button onClick={dismiss} data-testid="tour-welcome-close" aria-label="Dismiss"
            className="absolute top-3 right-3 text-white/50 hover:text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
          <div className="inline-flex items-center gap-2 text-teal-300 text-xs font-semibold uppercase tracking-wide mb-2">
            <Sparkles className="w-4 h-4" /> New here?
          </div>
          <p className="font-heading text-lg font-bold leading-snug">Take a 2-minute tour of the CRM</p>
          <p className="text-white/70 text-sm mt-1.5">We'll point out each tool in the menu and what it's for. You can stop any time.</p>
          <div className="flex items-center gap-2 mt-4">
            <button onClick={start} data-testid="tour-welcome-start"
              className="inline-flex items-center gap-2 bg-[#00A79D] hover:bg-[#00938a] text-white font-semibold px-4 py-2 rounded-lg text-sm transition-colors">
              <PlayCircle className="w-4 h-4" /> Start tour
            </button>
            <button onClick={dismiss} data-testid="tour-welcome-later"
              className="text-white/60 hover:text-white font-medium px-3 py-2 rounded-lg text-sm transition-colors">
              Not now
            </button>
          </div>
          <p className="text-white/40 text-[11px] mt-3">You can run it later from User Guide.</p>
        </div>
      </div>
    </div>
  );
}
